// Translate API feedback only; never alter titles, descriptions or user content.
export function translateApiMessages(data, translate, exists) {
  if (!data || typeof data !== 'object' || Array.isArray(data)) return data;
  const result = { ...data };
  for (const field of ['message', 'errorMessage', 'Message', 'ErrorMessage']) {
    const raw = result[field];
    if (typeof raw !== 'string') continue;
    let key = raw, params = data.params || {};
    if (raw.trim().startsWith('{')) {
      try { const parsed = JSON.parse(raw); key = parsed.key; params = parsed.params || {}; }
      catch { continue; }
    }
    if (typeof key === 'string' && /^(api\.|errors\.)/.test(key)) {
      result[field] = translate(exists(key) ? key : 'api.status.generic', params);
    }
  }
  return result;
}
